<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
      <!-- <template v-slot:divider>
        <v-icon>mdi-forward</v-icon>
      </template> -->
    </v-breadcrumbs>

    <v-card class="mx-16">
      <v-row dense
             class="d-flex mx-2">
        <v-col cols="12">
          <v-tabs vertical
                  center-active>
            <v-tab>
              <span class="font-weight-bold">Basic Information</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Samples</span>
            </v-tab>
            <!-- <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Differential Expression Genes</span>
            </v-tab> -->
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Transcriptomic Profiles</span>
            </v-tab>
            <!-- <v-tab>
              <span class="font-weight-bold">Differential Splicing Events</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Differential Transcript Usages</span>
            </v-tab> -->
            <!-- <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Isoform Switching</span>
            </v-tab> -->
            <v-tab-item>
              <v-col cols="12">
                <div class="ml-4">
                  <h3>
                    <a :href="bioprojectUrl+$route.params.id"
                       target="_blank">{{$route.params.id}}</a>: {{project_meta.title}}
                  </h3>
                </div>

                <div class="ml-4 d-flex mt-1">
                  <p class="mr-4"><span class="font-weight-bold">Source:</span> {{project_meta.data_resource}} / {{project_meta.original_project}}</p>
                  <p class="mx-4"><span class="font-weight-bold">Submission Date:</span> {{project_meta.submission_data}}</p>
                  <p class="mx-4"><span class="font-weight-bold">Release Date:</span> {{project_meta.release_data}}</p>
                  <p class="mx-4"><span class="font-weight-bold">Update Date:</span> {{project_meta.update_data}} </p>
                </div>

                <div class="ml-4">
                  <p>
                    <span class="font-weight-bold">Summary:</span> {{project_meta.summary}}
                  </p>
                  <p>
                    <span class="font-weight-bold">Overall Design:</span> {{project_meta.overall_design}}
                  </p>
                </div>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Strategy:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <span>
                        <v-chip outlined
                                color="info">{{project_meta.strategy}}</v-chip>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Tissue:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <span v-for="(tissue, index) in project_meta.tissue && project_meta.tissue.split(', ')"
                            :key="index"
                            class="v-item-group">
                        <v-chip outlined
                                class="mr-2"
                                color="info">{{tissue}}</v-chip>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Healthy Condition:</v-list-item-content>
                    <v-list-item-content>
                      <span v-for="(hc, index) in project_meta.healthy_condition && project_meta.healthy_condition.split(', ')"
                            :key="index"
                            class="v-item-group">
                        <v-chip outlined
                                class="mr-2"
                                color="success">{{hc}} ({{getControlCaseNumber(hc)}})</v-chip>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Library Layout:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <span>
                        <v-chip outlined
                                color="info">PAIRED</v-chip>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Reference Genome / Genome Annotation:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <span>
                        <v-chip outlined
                                color="info">hs37d5 / GENCODE V19</v-chip>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </v-col>
            </v-tab-item>

            <v-tab-item>
              <v-col cols="12">
                <!-- download function -->
                <div class="my-3"
                     v-if="selected.length > 0">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="success"
                             dark
                             v-bind="attrs"
                             v-on="on"
                             rounded
                             small
                             class="ml-2">
                        <span class="font-weight-bold">Download</span>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-title>
                          <json-excel type="xls"
                                      :data="selected"
                                      :name="$route.params.id + '-Meta.xls'">
                            <v-btn text
                                   block> <span class="font-weight-bold">xls</span> </v-btn>
                          </json-excel>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <json-excel type="csv"
                                      :data="selected"
                                      :name="$route.params.id + '-Meta.csv'">
                            <v-btn text
                                   block> <span class="font-weight-bold">csv</span> </v-btn>
                          </json-excel>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <v-expansion-panels class="data-table-style">
                  <v-expansion-panel>
                    <v-expansion-panel-header expand-icon="mdi-menu-down"
                                              style="padding: 10px 25px">
                      <div class="d-flex font-weight-bold">
                        <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                        <v-chip outlined
                                small
                                color="success"
                                class="ml-2"
                                @click="showAll()">
                          Select All
                        </v-chip>
                        <v-chip outlined
                                small
                                color="error"
                                class="ml-2"
                                @click="showDefault()">
                          Select Default
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="v-item-group">
                        <v-checkbox v-for="(header, index) in headers"
                                    :key="index"
                                    :label="header.text"
                                    :value="header.text"
                                    v-model="selectedHeader"
                                    dense
                                    class="mx-1"></v-checkbox>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-data-table dense
                              v-model="selected"
                              class="data-table-style mt-1"
                              :headers="selectedHeaders"
                              fixed-header
                              :items="project_samples"
                              item-key="Experiment Accession"
                              :search="search"
                              show-select
                              :single-select="singleSelect"
                              :loading="loading"
                              loading-text="Loading... Please wait"
                              :items-per-page="itemsPerPage"
                              :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-page-first',
      lastIcon: 'mdi-page-last',
      'items-per-page-options':[5,10,15,20,50,100,-1] }"
                              v-show="selectedHeaders && selectedHeaders.length > 0">
                  <!-- header.data-table-select slot-->
                  <template v-slot:[`header.data-table-select`]="{ on, props }">
                    <v-simple-checkbox color="success"
                                       v-bind="props"
                                       v-on="on"></v-simple-checkbox>
                  </template>

                  <!-- item.data-table-select slot -->
                  <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                    <v-simple-checkbox color="info"
                                       :value="isSelected"
                                       @input="select($event)"></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-col>
            </v-tab-item>

            <v-tab-item>
              <v-col cols="12"
                     class="mx-4">
                <!-- <h3>Transcriptomic Profiles</h3> -->
                <!-- <div class="mt-2">
                  <span>Note: </span>
                  <v-chip color="primary"
                          text
                          small
                          class="mx-1"><span class="font-weight-bold">Gene / Isoform Expression Profiles</span></v-chip>
                  <v-chip color="info"
                          small
                          class="mx-1"><span class="font-weight-bold">Alternative Splicing Profiles</span></v-chip>
                  <v-chip color="success"
                          small
                          class="mx-1"><span class="font-weight-bold">Isoform Switching Profiles</span></v-chip>
                </div>
                <v-divider class="mt-4"> </v-divider> -->
                <div class="mt-3">
                  <span class="font-weight-bold info--text">Gene / Isoform Expression Profiles</span>
                  <v-btn color="info"
                         rounded
                         class="ml-2"
                         small
                         :loading="exp_loading"
                         @click="downloadFiles('GEO/Expression/'+$route.params.id+'_expression.tar.gz')">
                    <v-icon small
                            left
                            color="white">mdi-download</v-icon>
                    <span class="font-weight-bold white--text">Download</span>
                  </v-btn><br>
                  <span>Reference Genome: hs37d5</span><br>
                  <span>Genome Annotation: GENCODE V19</span><br>
                  <span>Data Processing:
                    <ol>
                      <li>Quality Control: FastQC v0.11.9 + Trim Galore v0.6.6</li>
                      <li>Read Mapping: STAR v2.5.3a</li>
                      <li>Expression Quantification: RSEM v1.3.1</li>
                      <li>Differential Expression Genes: limma v3.50.3</li>
                      <li>Differential Transcript Usage: SUPPA2 v2.3.0</li>
                    </ol>
                  </span>
                </div>
                <v-divider class="mt-4"> </v-divider>
                <div class="mt-3">
                  <span class="font-weight-bold success--text">Alternative Splicing Profiles</span>
                  <v-btn color="success"
                         class="ml-2"
                         small
                         rounded
                         :loading="rmats_loading"
                         @click="downloadFiles('GEO/PSI/'+$route.params.id+'_PSI.tar.gz')">
                    <v-icon small
                            left>mdi-download</v-icon>
                    <span class="font-weight-bold">Download (rMATS)</span>
                  </v-btn>
                  <v-btn color="success"
                         class="ml-2"
                         small
                         rounded
                         :loading="suppa2_loading"
                         @click="downloadFiles('GEO/PSI/'+$route.params.id+'_suppa2.tar.gz')">
                    <v-icon small
                            left>mdi-download</v-icon>
                    <span class="font-weight-bold">Download (SUPPA2)</span>
                  </v-btn><br>
                  <span>Data Processing:
                    <ol>
                      <li>Alternative Splicing Identification: rMATS-turbo v4.1.1</li>
                      <li>Alternative Splicing Identification: SUPPA2 v2.3.0</li>
                    </ol>
                  </span>
                </div>
                <!-- <v-divider class="mt-4"> </v-divider>
                <div class="mt-3">
                  <span class="font-weight-bold success--text">Isoform Switching Profiles</span>
                  <v-chip color="success"
                          class="ml-2"
                          small
                          @click="downloadFiles()">
                    <v-icon small
                            left>mdi-download</v-icon>
                    <span class="font-weight-bold">Download</span>
                  </v-chip><br>
                  <span>Data Processing:
                    <ol>
                      <li>Isoform Switching Identification: IsoformSwitchAnalyzeR v1.18.0</li>
                    </ol>
                  </span>
                </div> -->
              </v-col>
            </v-tab-item>

            <!-- <v-tab-item>
              <v-col cols="12">
                <v-tabs background-color="grey lighten-5"
                        center-active
                        color="info">
                  <v-tab>DEG Heatmap</v-tab>
                  <v-divider vertical
                             inset></v-divider>
                  <v-tab>Up Regulated Genes</v-tab>
                  <v-divider vertical
                             inset></v-divider>
                  <v-tab>Down Regulated Genes</v-tab>
                  <v-tab-item>Heatmap</v-tab-item>
                  <v-tab-item>
                  </v-tab-item>
                  <v-tab-item>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-tab-item> -->
            <!-- <v-tab-item>
              <v-col cols="12">
                <v-tabs background-color="grey lighten-5"
                        center-active
                        color="info">
                  <v-tab>rMATS</v-tab>
                  <v-divider vertical
                             inset></v-divider>
                  <v-tab>SUPPA2</v-tab>
                  <v-tab-item>
                  </v-tab-item>
                  <v-tab-item>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                Differential Transcript Usage
              </v-col>
            </v-tab-item> -->
            <!-- <v-tab-item>
              <v-col cols="12">
                IsoformSwitchAnalyzeR
                <v-img src="../../assets/img/IsoformSwitchR.png"></v-img>
              </v-col>
            </v-tab-item> -->
          </v-tabs>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import JsonExcel from 'vue-json-excel';

import { getGeoMeta } from "node/projects"
import { downloadFiles } from 'node/download.js';
export default {
  name: 'GEO',
  components: {
    JsonExcel,
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Projects',
          disabled: true,
        },
        {
          text: 'GEO',
          disabled: false,
          href: '/ascancer/projects/geo',
        },
        {
          text: this.$route.params.id,
          disabled: true,
        },
      ],
      bioprojectUrl: "https://www.ncbi.nlm.nih.gov/bioproject/",
      project_meta: {},
      project_samples: [],
      selectedHeader: ['Experiment Accession', 'BioProject ID',
        'Species', 'Tissue', 'Healthy Condition', 'Case/Control',
        'Case Detail', 'Control Detail', 'Filter'],
      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      itemsPerPage: 20,
      headers: [
        { text: 'Experiment Accession', value: 'Experiment Accession', align: 'start', sortable: true, },
        { text: 'Data Resource', value: 'Data Resource', align: 'start', sortable: true, },
        { text: 'Original Project ID', value: 'Original Project ID', align: 'start', sortable: true },
        { text: 'BioProject ID', value: 'BioProject ID', align: 'start', sortable: false, },
        { text: 'Species', value: 'Species', align: 'start', },
        { text: 'Sample ID', value: 'Sample ID', align: 'start', sortable: false, },
        { text: 'Sample Name', value: 'Sample Name', align: 'start' },
        { text: 'BioSample ID', value: 'BioSample ID', align: 'start' },
        { text: 'Release Date', value: 'Release Date', align: 'start' },
        { text: 'Submission Date', value: 'Submission Date', align: 'start' },
        { text: 'Update Date', value: 'Update Date', align: 'start' },
        { text: 'Race', value: 'Race/Breed/Strain', align: 'start' },
        { text: 'Ethnicity', value: 'Ethnicity', align: 'start' },
        { text: 'Age', value: 'Age', align: 'start' },
        { text: 'Gender', value: 'Gender', align: 'start' },
        { text: 'Source Name', value: 'Source Name', align: 'start' },
        { text: 'Tissue', value: 'Tissue', align: 'start' },

        // { text: 'Mutation', value: 'Mutation', align: 'start' },
        { text: 'Healthy Condition', value: 'Cancer Type', align: 'start' },
        { text: 'Cancer Stage', value: 'Cancer Stage', align: 'start' },
        { text: 'Case/Control', value: 'Case/Control', align: 'start' },
        { text: 'Case Detail', value: 'Case Detail', align: 'start' },
        { text: 'Control Detail', value: 'Control Detail', align: 'start' },
        { text: 'Strategy', value: 'Strategy', align: 'start' },
        { text: 'Molecule Type', value: 'Molecule Type', align: 'start' },
        { text: 'Library Layout', value: 'Library Layout', align: 'start' },
        { text: 'Platform', value: 'Platform', align: 'start' },
        { text: 'Instrument Model', value: 'Instrument Model', align: 'start' },

        { text: 'Reads', value: 'Reads', align: 'start', sortable: false, },
        { text: 'GC', value: 'GC', align: 'start', sortable: false, },
        { text: 'AvgSpotlen1', value: 'AvgSpotlen1', align: 'start', sortable: false, },
        { text: 'AvgSpotlen2', value: 'AvgSpotlen2', align: 'start', sortable: false, },
        { text: 'Unique Mapping', value: 'Unique Mapping', align: 'start', sortable: false, },
        { text: 'Multi Mapping', value: 'Multi Mapping', align: 'start', sortable: false, },
        { text: 'Coverage Rate', value: 'Coverage Rate', align: 'start', sortable: false, },
        { text: 'Reference Genome', value: 'Reference Genome', align: 'start', sortable: false, },
        { text: 'Genome Annotation', value: 'Genome Annotation', align: 'start', sortable: false, },
        { text: 'Filter', value: 'Filter', align: 'start', sortable: false, },
        // { text: 'PMID', value: 'PubMed', align: 'start', sortable: false, },
      ],
      pubmedLink: 'https://pubmed.ncbi.nlm.nih.gov/',
      exp_loading: false,
      rmats_loading: false,
      suppa2_loading: false,

    }
  },
  created() {
    this.getGeoMeta();
  },
  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    }
  },
  watch: {
    project_samples(val) {
      if (val) {
        this.loading = false;
      }
    },
  },
  methods: {
    // get all GEO meta info
    async getGeoMeta() {
      let id = this.$route.params.id;
      await getGeoMeta(id).then(
        data => {
          if (data) {
            // console.log(data);
            this.project_meta = data[0];
            this.project_samples = data[0].samples;
          }
        }
      ).catch(err => console.error(err))
    },
    getControlCaseNumber(hc) {
      return this.project_samples.filter(d => d['Cancer Type'] == hc).length
    },
    downloadFiles(fileName) {
      if (fileName.endsWith('expression.tar.gz')) {
        this.exp_loading = true;
      } else if (fileName.endsWith('PSI.tar.gz')) {
        this.rmats_loading = true;
      } else {
        this.suppa2_loading = true;
      }
      downloadFiles(fileName).then(res => {
        if (res) {
          this.exp_loading = false;
          this.rmats_loading = false;
          this.suppa2_loading = false;
        }
        // console.log(res); // 返回 Blob 形式,并不会直接进行下载，需创建一个 a 标签去触发下载
        // console.log("success");

        // 将 axios 中 responseType 设置为 blob, 以 blob 形式获取到文件之后,
        // 创建一个 a 标签，设置 url 和 downlaod 后并触发，最后释放 url 资源并删除创建的a标签
        const link = document.createElement('a');
        link.download = fileName;
        link.style.display = 'none'
        // link.href = window.URL.createObjectURL(new Blob([res]));
        link.href = window.URL.createObjectURL(res);

        document.body.appendChild(link)
        link.click()

        //释放URL对象所占资源
        window.URL.revokeObjectURL(link.href)
        //用完即删
        document.body.removeChild(link)
      }).catch(err => {
        console.error(err);
      })
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Experiment Accession', 'BioProject ID',
        'Species', 'Tissue', 'Healthy Condition', 'Case/Control',
        'Case Detail', 'Control Detail', 'Filter'];
    },
  }

}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

// .v-sheet.v-card
//   border-radius: 15px

.v-card__title
  line-height: 0.5rem

.v-tab
  text-transform: none
  justify-content: flex-start

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.disable-cursor
  cursor: auto

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>